import { useMutation } from '@tanstack/react-query';
import axios from 'axios';
import ApiConfig from 'src/config/api-config';

export interface UpdateProgramSchedulePayload {
  clientId: string;
  trainerId: string;
  programId: string;
  datetimeList: any[];
  changeType?: 'permanent' | 'temporary';
  howOftenTrain?: Array<{ slug: string; value: string }>;
}

export const useUpdateProgramSchedule = () => {
  return useMutation({
    mutationFn: async (payload: UpdateProgramSchedulePayload) => {
      const response = await axios.post(
        `${ApiConfig.CLOUD_FUNCTIONS_BASE_URL}${ApiConfig.TRAINER_UPDATE_PROGRAMME_CALENDAR}`,
        { data: payload },
        {
          headers: {
            'Content-Type': 'application/json',
          },
        },
      );

      return response.data;
    },
  });
};
